import { createApp } from 'vue'
import App from './App.vue'
import wx from 'weixin-js-sdk'
import store from '../../store'
import toast from '@/components/tf-toast'
import loading from '@/components/tf-loading'
import * as Sentry from "@sentry/vue";

const app = createApp(App)
if(process.env.VITE_APP_ENV === 'production'){
  Sentry.init({
    app,
    dsn: "https://886a805414de6aab2e4ed4c3f692d6cc@tf-sentry.tongfuyouxuan.com/5",
    integrations: [
      new Sentry.BrowserTracing({
        // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
  
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
app.config.globalProperties.$wx = wx
app.config.globalProperties.$toast = toast
app.use(loading)
app.use(store)
app.mount('#app')